// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604291503/js/" + chunkId + "." + {"44":"dd9e02df","225":"a7581140","481":"fe0f1506","486":"228e0c38","770":"cebfa04b"}[chunkId] + ".0.7199127843719815.chunk.js";
};